/**
 * Payload builders for the audio_failed / audio_retry / session_checkpoint_failed
 * telemetry rows (job #813). The row already carries learner (payload.learnerId),
 * course_code, client_version and session_id; what it could not say was WHICH
 * KIND OF DEVICE stalled. `deviceClass` is deliberately coarse (os/browser/shell)
 * so it groups rather than fingerprints. Everything here can never throw.
 */
export interface AudioFailureLike {
  reason?: string
  role?: string
  cycleType?: string
  legoId?: string
  cycleId?: string
  errorCode?: number
  attempt?: number
  lastError?: string
  consecutiveSkips?: number
}

/** e.g. "ios-safari", "android-chrome", "desktop-firefox", "ios-webview" — never the raw UA. */
export function deviceClass(ua?: string | null): string {
  try {
    const u = ua ?? (typeof navigator !== 'undefined' ? navigator.userAgent : '') ?? ''
    const os = /iPhone|iPad|iPod/i.test(u) ? 'ios' : /Android/i.test(u) ? 'android' : /Mac OS X|Windows|Linux|CrOS/i.test(u) ? 'desktop' : 'other'
    if (/SSiShell\//.test(u)) return `${os}-shell`
    const browser = /Edg\//.test(u) ? 'edge' : /Firefox|FxiOS/.test(u) ? 'firefox' : /Chrome|CriOS/.test(u) ? 'chrome' : /Safari/.test(u) ? 'safari' : 'other'
    return `${os}-${browser}`
  } catch {
    return 'unknown'
  }
}

export function buildAudioFailurePayload(event: AudioFailureLike, ua?: string | null): Record<string, unknown> {
  const out: Record<string, unknown> = {
    reason: event.reason,
    role: event.role,
    cycleType: event.cycleType,
    legoId: event.legoId,
    cycleId: event.cycleId,
    errorCode: event.errorCode,
    attempt: event.attempt,
    lastError: event.lastError,
    consecutiveSkips: event.consecutiveSkips,
  }
  out.deviceClass = deviceClass(ua)
  return out
}
